import {ContentTypes, getApi, postApi} from "../../common/actions/net.js";
import { messageType, pushSystemMessage } from "../../common/actions/systemMessage.js";

import Logger from "../../common/util/Logger.js";
import { createLocalizeFunction } from "../../common/util/localization.jsx";
import {setCurrentLanguage} from "../../common/actions/userSettings.js";

export const SET_CUSTOMER_INFO = "SET_CUSTOMER_INFO";
export const SET_CUSTOMER_LOGO = "SET_CUSTOMER_LOGO";

export const CONTACT_INFORMATION_SAVING = "CONTACT_INFORMATION_SAVING";
export const CONTACT_INFORMATION_SAVED = "CONTACT_INFORMATION_SAVED";
export const CONTACT_INFORMATION_FAILED = "CONTACT_INFORMATION_FAILED";

export const EDIT_CONTACT_INFORMATION = "EDIT_CONTACT_INFORMATION";

const setCustomerInfo = (customerInfo) => ({
    type: SET_CUSTOMER_INFO,
    customerInfo
});

const setCustomerLogo = (logoUrl) => ({
    type: SET_CUSTOMER_LOGO,
    logoUrl
});

/**
 * sätter kundens välkomsinformation
 * @param {string} cusNo 
 * @returns {func}
 */
export function getCustomerInfo(cusNo){
    return async (dispatch) => {
        try {
            dispatch(setCurrentLanguage("no"));
            const {payload} = await dispatch(getApi(`Customer/GetCustomerWelcomeInfo/${cusNo ? cusNo : ""}`, {}));
            dispatch( setCustomerInfo(payload) );
            //get logo
            const url = await dispatch(getApi(`Customer/GetCustomerLogoImage/${payload.customerId}/${payload.logoImageFileName}`, {}, ContentTypes.JSON, ContentTypes.IMAGE));
            //const url = await dispatch(getApi("Customer/GetCustomerLogoImage", {customerId: payload.customerId,imageName: payload.logoImageFileName}, ContentTypes.JSON, ContentTypes.IMAGE));
            dispatch( setCustomerLogo(url) );
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av brukerinfo mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Laddar ner kundens egna välkomstinfo
 * @returns {func}
 */
export function getOwnCustomerWelcomeInfo() {
    return async (dispatch, getState) => {
        const state = getState();
        const {payload} = await dispatch(getApi(`Customer/GetCustomerWelcomeInfo/${state.authentication.signedInAs}`, {}));
        dispatch( setCustomerInfo(payload) );
    };
}

/**
 * Sparar kontaktinformationen för den egna kunden.
 * @param {string} contact - Namn på kontaktpersonen
 * @param {string} email - Email till kontakpersonen
 * @param {string} mobile - Telefonnummer till kontaktpersonen
 * @param {string} [contact2] - Namn på kontaktperson 2
 * @param {string} [email2] - Email till kontakperson 2
 * @param {string} [mobile2] - Telefonnummer till kontaktperson 2
 * @returns {func}
 */
export function saveContactInformation(contact, email, mobile, contact2, email2, mobile2) {
    return async (dispatch, getState) => {
        dispatch({
            type: CONTACT_INFORMATION_SAVING
        });

        if (contact2) {
            if (contact2.trim().length === 0) {
                contact2 = null;
            }
        }

        if (email2) {
            if (email2.trim().length === 0) {
                email2 = null;
            }
        }

        if (mobile2) {
            if (mobile2.trim().length === 0) {
                mobile2 = null;
            }
        }

        try {
            await dispatch(postApi("Customer/CustomerContactsCommand", {
                contact,
                email,
                mobile,
                contact2,
                email2,
                mobile2
            }));
            dispatch({
                type: CONTACT_INFORMATION_SAVED,
                contact,
                email,
                mobile,
                contact2,
                email2,
                mobile2
            });
        } catch (_) {
            dispatch({
                type: CONTACT_INFORMATION_FAILED
            });
            const localize = createLocalizeFunction(getState());
            
            dispatch(pushSystemMessage(localize("myAccount", "couldNotSave"), localize("myAccount", "error")));
        }
    };
}